import { render, staticRenderFns } from "./VesselWhitelistRulePanel.vue?vue&type=template&id=bfd93002&scoped=true"
import script from "./VesselWhitelistRulePanel.vue?vue&type=script&lang=js"
export * from "./VesselWhitelistRulePanel.vue?vue&type=script&lang=js"
import style0 from "./VesselWhitelistRulePanel.vue?vue&type=style&index=0&id=bfd93002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd93002",
  null
  
)

export default component.exports